module.exports = __webpack_public_path__ + "admin/img/payment_newebpay_logo.a0f4780c.png";